export { default } from "./HistoricoVentasSemana";
